import React from 'react';
import axios from 'axios';
import {
  Heading,
  Avatar,
  Box,
  Center,
  Image,
  Flex,
  Text,
  Stack,
  Link,
  Badge,
  Button,
  useColorModeValue,
  Divider,
  SimpleGrid,
  HStack,
} from '@chakra-ui/react';
import { EditIcon } from '@chakra-ui/icons';

import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  StackDivider,
} from '@chakra-ui/react';
import {
  chakra,
  Container,
  VStack,
  VisuallyHidden,
  List,
  ListItem,
} from '@chakra-ui/react';

export default function PJobProfile() {
  const [data, setData] = React.useState([]);
  React.useEffect(() => {
    axios.get('https://glb-api.onrender.com/student/work')
    .then(res => {
      console.log(res.data);

      setData(res.data);
    })
    .catch(err => {
      console.log(err);
      // setError('Failed to fetch the details right now.')
    })
  }, [])
  return (
    <>
      <div>
        <Box>
          <Card variant={'elevated'} minH={'100vh'}>
            <CardBody>
              <Box bg="white" shadow="md" borderRadius="md" p="6" width="100%">
                <Flex alignItems="center" justifyContent="space-between">
                  <Heading as="h1" size="2xl">
                    Position of Responsibilities
                  </Heading>
                  <Button
                    leftIcon={<EditIcon />}
                    marginTop={'4px'}
                    colorScheme="blue"
                    variant="outline"
                    size={'lg'}
                    display={{ base: 'none', md: 'inline-flex' }}
                    fontSize={'2xl'}
                    href={'#'}
                  >
                    Edit info
                  </Button>
                </Flex>
              </Box>

              <Box className="mt-10">
                <VStack spacing={10}>
                  <Center width={'100%'}>
                    <Box width={'100%'}>
                      <Card variant={'elevated'}>
                        <CardHeader>
                          <Box bg="white" p={5} borderRadius="md">
                            <Heading as="h2" textAlign="left" size="2xl" mb={3}>
                              {data.job?.title}
                            </Heading>

                            <Flex marginTop={'20px'}>
                              <Avatar
                                src="https://images.unsplash.com/photo-1498050108023-c5249f4df085?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1172&q=80"
                                size={'xl'}
                              />
                              <Box ml="3">
                                <Text fontWeight="bold" fontSize={'x-large'}>
                                  {data.job?.organisation}
                                  {data.job?.current==false ? (<Badge ml="1" size={'lg'} colorScheme="yellow">
                                  Past!
                                  </Badge>) : (<Badge ml="1" size={'lg'} colorScheme="green">
                                  Current!
                                  </Badge>)}

                                </Text>
                                <Text fontSize="lg">
                                  {data.job?.tenure.start} - {data.job?.current==false ? ('Past') : ('Current')} | Indore
                                </Text>
                                <Divider marginTop={'10px'} />
                                <Text fontSize="lg" marginTop={"10px"}>
                                {data.job?.description}
                  </Text>

                              </Box>
                            </Flex>
                          </Box>


                        </CardHeader>

                        <CardBody></CardBody>
                      </Card>
                    </Box>
                  </Center>
                </VStack>
              </Box>
              <Box className="mt-10">
                <VStack spacing={10}>
                  <Center width={'100%'}>
                    <Box width={'100%'}>
                      <Card variant={'elevated'}>
                        <CardHeader>
                          <Box bg="white" p={5} borderRadius="md">
                            <Heading as="h2" textAlign="left" size="2xl" mb={3}>
                              {data.intern?.title} Intern
                            </Heading>

                            <Flex marginTop={'20px'}>
                              <Avatar
                                src="https://images.unsplash.com/photo-1498050108023-c5249f4df085?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1172&q=80"
                                size={'xl'}
                              />
                              <Box ml="3">
                                <Text fontWeight="bold" fontSize={'x-large'}>
                                  {data.intern?.organisation}
                                  {data.intern?.current==false ? (<Badge ml="1" size={'lg'} colorScheme="yellow">
                                  Past!
                                  </Badge>) : (<Badge ml="1" size={'lg'} colorScheme="green">
                                  Current!
                                  </Badge>)}

                                </Text>
                                <Text fontSize="lg">
                                  {data.intern?.tenure.start} - {data.intern?.current==false ? ('Past') : ('Current')} | Indore
                                </Text>
                                <Divider marginTop={'10px'} />
                                <Text fontSize="lg" marginTop={"10px"}>
                                {data.intern?.description}
                  </Text>

                              </Box>
                            </Flex>
                          </Box>


                        </CardHeader>

                        <CardBody></CardBody>
                      </Card>
                    </Box>
                  </Center>
                </VStack>
              </Box>
              <Box className="mt-10">
                <VStack spacing={10}>
                  <Center width={'100%'}>
                    <Box width={'100%'}>
                      <Card variant={'elevated'}>
                        <CardHeader>
                          <Box bg="white" p={5} borderRadius="md">
                            <Heading as="h2" textAlign="left" size="2xl" mb={3}>
                              UI/UX Intern
                            </Heading>

                            <Flex marginTop={'20px'}>
                              <Avatar
                                src="https://images.unsplash.com/photo-1498050108023-c5249f4df085?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1172&q=80"
                                size={'xl'}
                              />
                              <Box ml="3">
                                <Text fontWeight="bold" fontSize={'x-large'}>
                                  Auth0 (UI/UX Intern )
                                  <Badge ml="1" size={'lg'} colorScheme="yellow">
                                    Past
                                  </Badge>
                                </Text>
                                <Text fontSize="lg">
                                  January-2022 - October-2022 | Indore
                                </Text>
                                <Divider marginTop={'10px'} />
                                <Text fontSize="lg" marginTop={"10px"}>
                                I am thrilled to have been recognized for my contributions to the field of UI/UX design as an intern. This award is a testament to the hard work and dedication that I have put into learning and growing as a designer.

Throughout my internship, I have had the opportunity to work on a variety of projects, from creating wireframes and prototypes to conducting user research and usability testing. I have also collaborated closely with my team members to ensure that our designs are not only visually appealing but also intuitive and user-friendly.

My approach to UI/UX design is grounded in a deep understanding of user behavior and psychology. By incorporating insights from user research and testing, I have been able to create interfaces that are both aesthetically pleasing and highly functional.

I am grateful for the support and guidance that I have received from my mentors and colleagues during my internship. Their mentorship has allowed me to develop my skills and gain valuable experience in the field of UI/UX design.
                  </Text>

                              </Box>
                            </Flex>
                          </Box>


                        </CardHeader>

                        <CardBody></CardBody>
                      </Card>
                    </Box>
                  </Center>
                </VStack>
              </Box>
            </CardBody>
          </Card>
        </Box>
      </div>
    </>
  );
}
